export class AllocationViewSlotBriefLoad {
  public static readonly type = '[AllocationViewSlotBrief] Load Slot Brief';
  constructor(public payload: { compartmentId: number; slotId: number }) {}
}

export class AllocationViewSlotBriefInitialState {
  public static readonly type = '[AllocationViewSlotBrief] Set Initial State';
}
